module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/first.js
// module id = 1235
// module chunks = 0